import {useQuery} from '@apollo/react-hooks';

import type {
    GetNutshellMarketingStats as GetNutshellMarketingStatsQuery,
    GetNutshellMarketingStats_nutshellMarketingStats as NutshellMarketingStats,
} from 'nutshell-graphql-types';

import GET_USAGE_STATS from '../queries/get-usage-stats.graphql';

export function useGetUsageStats(): {
    nutshellMarketingStats: NutshellMarketingStats | null | undefined;
    isLoading: boolean;
} {
    const {data, loading} = useQuery<GetNutshellMarketingStatsQuery, Record<any, any>>(
        GET_USAGE_STATS,
        {
            notifyOnNetworkStatusChange: true,
        }
    );

    const nutshellMarketingStats = data ? data.nutshellMarketingStats : null;

    return {
        nutshellMarketingStats: nutshellMarketingStats || null,
        isLoading: loading,
    };
}
